module.exports = __webpack_public_path__ + "img/cms_assets_browse.b967c3af.png";